import { getVmModal } from "./plugin";

/**
 * グローバル関数: window.openModal
 *
 * HTML内から直接モーダルを開くための関数
 * 使用例: window.openModal({ vars: { title: '...', lead: '...' } })
 */
window.openModal = async (options, callback) => {
    const modal = getVmModal()
    if (!modal) return

    const result = await modal.open(options)

    // closeボタンを押した時
    if (result.action && typeof callback === 'function') {
        callback(result.payload)
    }

    return result
}

